import React from 'react';
import PropTypes from 'prop-types';

import { translateStaticContent } from '../../../helpers/translateStaticContent';

const PartnerRow = (props) => {
    let isActive = '';
    if (props.row.partnerInfoDto) {
        isActive = props.row.partnerInfoDto.isActive ? '' : 'disabled'
    }
    const transferAmount = () => {
        const staticFrom = translateStaticContent('tableDataFrom', 
                         props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs);
        const staticTo = translateStaticContent('tableDataTo', 
                         props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs);
        const staticAllValues = translateStaticContent('tableDataAllValues', 
                         props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs);
        let transferAmount = '';
        let minTransferAmount = +props.row.minTransferAmount < 1 ? 1 : props.row.minTransferAmount;
            if (minTransferAmount && props.row.maxTransferAmount) {
                transferAmount = `${minTransferAmount.toFixed(2)} - ${(props.row.maxTransferAmount).toFixed(2)}`;
            } else if (minTransferAmount && !props.row.maxTransferAmount) {
                transferAmount = `${staticFrom} ${(props.row.minTransferAmount).toFixed(2)}`;
            } else if (!minTransferAmount && props.row.maxTransferAmount) {
                transferAmount = `${staticTo} ${(props.row.maxTransferAmount).toFixed(2)}`;
            } else if (!minTransferAmount && !props.row.maxTransferAmount) {
                transferAmount = staticAllValues;
            }
        return transferAmount;
    }

    const currency = () => {
        let currency = '';
        if(props.currency) {
            currency = props.currency.join('/');
        } else {
            currency = props.row.toCurrency;
        }
        return currency;
    }

    const commission = () => {
        const staticMin = translateStaticContent('tableDataMin', 
                         props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs);
        let commission = '';
        const commissionPercent = props.row.commissionPercent ? 
                                  (props.row.commissionPercent*100).toFixed(2) : '';
        if (commissionPercent && props.row.minCommissionAmountInToCcy) {
            commission = `${commissionPercent}% ${staticMin}
                          ${(props.row.minCommissionAmountInToCcy).toFixed(2)} ${props.row.fromCurrency}`; 
        } else if (commissionPercent && !props.row.minCommissionAmountInToCcy) {
            commission = `${commissionPercent}%`;
        } else if (!commissionPercent && props.row.minCommissionAmountInToCcy) {
            commission = `${(props.row.minCommissionAmountInToCcy).toFixed(2)} ${props.row.fromCurrency}`;
        }
        return commission
    }
    
    const partner = () => {
        let resultPartner = '';
        const staticPartnersPoints = translateStaticContent('tableDataPartnersPoints', 
                                     props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs);
        const staticParticipantPoints = translateStaticContent('tableDataParticipantPoints', 
                                     props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs);
        const staticPartnersPointsSend = translateStaticContent('tableDataPartnersPointsSend', 
                                     props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs);
        const staticParticipantPointsSend = translateStaticContent('tableDataParticipantPointsSend', 
                                     props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs);
        if (props.row.partnerInfoDto && props.direction === 'in') {
            if (props.row.partnerInfoDto.partnerType.name === "Учасник") {
                resultPartner = `${staticParticipantPoints} "${props.row.partnerInfoDto.partnerName}"`
           } else if (props.row.partnerInfoDto.partnerType.name === "Партнер") {
               resultPartner = `${staticPartnersPoints} "${props.row.partnerInfoDto.partnerName}"`
           } 
        } else if (props.row.partnerInfoDto && props.direction === 'out') {
            if (props.row.partnerInfoDto.partnerType.name === "Учасник") {
                resultPartner = `${staticParticipantPointsSend} "${props.row.partnerInfoDto.partnerName}"`
           } else if (props.row.partnerInfoDto.partnerType.name === "Партнер") {
               resultPartner = `${staticPartnersPointsSend} "${props.row.partnerInfoDto.partnerName}"`
           }
        }
        return resultPartner;
    }
     return(
        <div className={`partner-row ${isActive}`}>
            <div className="table-column currency">
                 <div className="table-header">
                    {translateStaticContent('tableDataCurrency', 
                        props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs)}
                </div>
                <div className="table-data">
                    {currency()}
                </div>
            </div>
            <div className="table-column transferAmount">
                <div className="table-header">
                    {translateStaticContent('tableDataSum', 
                        props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs)}
                </div>
                <div className="table-data">
                    {transferAmount()}
                </div>
            </div>
            <div className="table-column commission">
                <div className="table-header">
                    {translateStaticContent('tableDataCommission', 
                        props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs)}
                </div>
                <div className="table-data">
                    {commission()}
                </div>
            </div>
            <div className="table-column partners">
                 <div className="table-header">
                    {translateStaticContent('tableDataPartners', 
                        props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs)}
                </div>
                <div className="table-data partner">
                    {partner()}
                    <div className='disabled'>(
                        {translateStaticContent('tableDataMessage', 
                            props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs)}
                        )
                    </div>
                </div>
             </div>
        </div>
    )  
}

export default PartnerRow;

PartnerRow.propTypes = {
    row: PropTypes.object.isRequired,
    currency: PropTypes.array,
    defaultStaticContentTariffs: PropTypes.object,
    activeLangStaticContentTariffs: PropTypes.object,
    direction:  PropTypes.string.isRequired,
}